import config from "../../../config";

/**
 * Pushes the entity's own workspace photo (Product Info / Project Info,
 * already fetched as a blob via Product.get_photo/Project.get_photo) into
 * the same emission_reference_files "DPP Evidence" gallery that the Photo
 * section, Preview, Evidence Repository, downloaded PDF, and public summary
 * page all already read from — so it shows up everywhere without those
 * surfaces needing any changes.
 *
 * Re-running this (re-clicking "Load from Arivu") replaces only the single
 * row it created last time (tagged is_workspace_import), identified by
 * fetching the current file list first — photos the user uploaded manually
 * through the DPP's own Photo section are left untouched.
 */
export const importWorkspacePhotoToEvidence = async (photoBlob, entityId, idColumnName) => {
  if (!photoBlob || !entityId) return;
  try {
    const existing = await fetch(`${config.apiUrl}/api/fetch_emission_reference_files?ID=${entityId}`).then((res) => res.json());
    const priorImport = (existing || []).find((f) => f.scope === "DPP Evidence" && f.is_workspace_import);
    if (priorImport) {
      await fetch(`${config.apiUrl}/api/delete_emission_reference_files`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ file_ids: [priorImport.id], file_urls: [priorImport.url] }),
      });
    }

    // The uploaded filename must be unique per entity — uploads land in one
    // shared folder on disk with no per-entity subfolder, so a fixed literal
    // filename here would make every entity's import overwrite the same
    // physical file, and every other entity's evidence row (which points at
    // that same file_url) would then show whichever entity imported last.
    const formData = new FormData();
    formData.append("files", photoBlob, `workspace_photo_${idColumnName}_${entityId}.jpg`);
    formData.append("rowID", entityId);
    formData.append("scope", "DPP Evidence");
    formData.append("IDColumnName", idColumnName);
    formData.append("isPhoto", "true");
    formData.append("isWorkspaceImport", "true");
    await fetch(`${config.apiUrl}/api/upload_emission_reference_files`, { method: "POST", body: formData });
  } catch (err) {
    console.error("[importWorkspacePhotoToEvidence] Failed:", err);
  }
};
